var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldDocumentFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.36 1c.68 0 1.23.56 1.23 1.25v1.37c0 .5-.31 1.12-.62 1.43L9.33 7.43c-.37.31-.61.93-.61 1.43v2.68c0 .37-.25.87-.55 1.06l-.87.57c-.8.5-1.91-.06-1.91-1.06V8.8c0-.44-.25-1-.49-1.31l-2.34-2.5C2.25 4.68 2 4.12 2 3.75V2.31C2 1.56 2.55 1 3.23 1h8.13z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6 2c-.28 0-.5.22-.5.5v1.12c0 .99-.53 1.96-1.05 2.49l-2.72 2.43c-.03.07-.08.17-.11.25v2.75c0 .91-.54 1.9-1.28 2.35l-.82.53c-.46.29-.97.43-1.48.43-.46 0-.92-.12-1.34-.35-.65-.36-1.1-.95-1.3-1.63v-2.66a.47.47 0 0 0-.15-.35l-1-1a.495.495 0 0 0-.85.35V17c0 2.76 2.24 5 5 5h10c2.76 0 5-2.24 5-5V7c0-2.76-2.24-5-5-5h-2.4zM11 17.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7c.41 0 .75.34.75.75s-.34.75-.75.75h-7zm2-4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c.41 0 .75.34.75.75s-.34.75-.75.75h-5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldDocumentFilter);
export default __webpack_public_path__ + "static/media/vuesax-bold-document-filter.68709afd4051c713930c00782e1e53af.svg";
export { ForwardRef as ReactComponent };